import TranslateNew from '@translate/TranslateNew';
import { CountryType } from './holidayTypes';

interface ISchoolVacationCountryOption {
  value: string;
  label: string;
}

const SCHOOL_VACATION_COUNTRY_VALUES = [
  "us", "ca", "uk", "se", "fi", "no", "dk", "es", "ch", "de", "fr", "be", "nl",
  "nz", "is", "ee", "lv", "lt", "ie", "lu", "at", "pt", "mt", "gr", "cy", "pl",
  "cz", "it", "au",
];

const SCHOOL_VACATION_COUNTRY_ALIASES: { [key: string]: string } = {
  gb: "uk",
};

const SCHOOL_VACATION_HOLIDAY_COUNTRIES: { [key: string]: CountryType } = {
  se: "SE",
  us: "US",
  uk: "GB",
  no: "NO",
  fi: "FI",
  dk: "DK",
  es: "ES",
  de: "DE",
  fr: "FR",
  be: "BE",
  nl: "NL",
  ca: "CA",
  it: "IT",
  ch: "CH",
  at: "AT",
  pl: "PL",
  ie: "IE",
  pt: "PT",
  gr: "GR",
  au: "AU",
};

export function normalizeSchoolVacationCountry(country: string | undefined): string {
  const normalizedCountry = (country || "us").toLowerCase();
  const countryValue = SCHOOL_VACATION_COUNTRY_ALIASES[normalizedCountry] || normalizedCountry;

  return SCHOOL_VACATION_COUNTRY_VALUES.indexOf(countryValue) === -1 ? "us" : countryValue;
}

export function getHolidayCountryForSchoolVacation(country: string): CountryType | undefined {
  return SCHOOL_VACATION_HOLIDAY_COUNTRIES[normalizeSchoolVacationCountry(country)];
}

export function getSchoolVacationCountryOptions(): ISchoolVacationCountryOption[] {
  const tn = TranslateNew.getInstance();

  return [
    { value: "us", label: tn.lang.us },
    { value: "ca", label: tn.lang.ca },
    { value: "uk", label: tn.lang.uk },
    { value: "se", label: tn.lang.sweden },
    { value: "fi", label: tn.lang.finland },
    { value: "no", label: tn.lang.norway },
    { value: "dk", label: tn.lang.denmark },
    { value: "es", label: tn.lang.spain },
    { value: "ch", label: tn.lang.switzerland },
    { value: "de", label: tn.lang.germany },
    { value: "fr", label: tn.lang.france },
    { value: "be", label: tn.lang.belgium },
    { value: "nl", label: tn.lang.nl },
    { value: "nz", label: tn.lang.newzealand },
    { value: "is", label: tn.lang.iceland },
    { value: "ee", label: tn.lang.estonia },
    { value: "lv", label: tn.lang.latvia },
    { value: "lt", label: tn.lang.lithuania },
    { value: "ie", label: tn.lang.ireland },
    { value: "lu", label: tn.lang.luxembourg },
    { value: "at", label: tn.lang.austria },
    { value: "pt", label: tn.lang.portugal },
    { value: "mt", label: tn.lang.malta },
    { value: "gr", label: tn.lang.greece },
    { value: "cy", label: tn.lang.cyprus },
    { value: "pl", label: tn.lang.poland },
    { value: "cz", label: tn.lang.czechia },
    { value: "it", label: tn.lang.italy },
    { value: "au", label: tn.lang.australia },
  ];
}



// WEBPACK FOOTER //
// ./src/components/calendar2/holidays/schoolVacationCountries.ts